<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="MID"
        v-model="searchData.mid"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { dataJenisPromoList } from '../../store/params';

export default {
  props: ['search'],
  data: () => ({
    startDatetime: '',
    dateStartPopup: false,
    endDatetime: '',
    dateEndPopup: false,
    jenisPromoList: dataJenisPromoList,
    searchIssuer: '',
  }),
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
  },
  methods: {
    getData() {
      this.$emit('getDataParent');
    },
  },
};
</script>
